// extracted by mini-css-extract-plugin
module.exports = {"grid":"RegistrationPaymentStepOverview_grid_68Kks"};